/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import Amazon from "../../../src/components/amazon";
import Hatena from "../../../src/components/hatena";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(Hatena, {
    src: "https://www.youtube.com/watch?v=SHeUvLXaycc",
    title: ""
  }), "\n", React.createElement(_components.p, null, "　　文字コード判別が失敗していた。原因は青空文庫のテキストを2回読み込むのを一回だけ読み込んでいたことによるもの。更に、ウェブ小説を読み込む場合は強制的にUTF-8に指定していてから元の設定に戻す処理が複雑に絡み合っている。"), "\n", React.createElement(_components.p, null, "　なのでコードの失敗をなくすにはウェブ小説の文字コード指定をなくして一本化させるのがいいのだろう。"), "\n", React.createElement(Hatena, {
    src: "https://github.com/kyukyunyorituryo/AozoraEpub3/releases/tag/v1.1.1b14Q",
    title: ""
  }), "\n", React.createElement(Hatena, {
    src: "https://www.vector.co.jp/soft/winnt/writing/se522586.html",
    title: ""
  }));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
